<template>
  <!--政府表单-->
  <div class="otherBox">
    <el-form ref="otnerform" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="单位全称" prop="name">
        <el-input v-model="form.name" style="width:400px" placeholder="单位全称"></el-input>
      </el-form-item>
      <el-form-item label="单位地址" prop="address">
        <dataTree @change='changeId' :defaultData='defaultPointerData'></dataTree>
        <el-input v-model="form.address" style="width:400px;display:block;margin-top:22px" placeholder="街道详细地址"></el-input>
      </el-form-item>
      <el-form-item label="联系人" label-width="120px" prop="linkMan">
        <el-input v-model="form.linkMan" placeholder="联系人" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" label-width="120px" prop="phone">
        <el-input v-model="form.phone" placeholder="联系电话" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="中心坐标" label-width="120px" prop="latitude">
        <el-button @click="showMap.state = true">地图选点</el-button>
        <span style="margin-left: 5px">东经：{{form.longitude | formatDegree}}，北纬：{{form.latitude | formatDegree}}</span>
<!--        <el-input style="width:150px" v-model.number="form.longitude" placeholder="经度"></el-input>-->
<!--        <el-input style="width:150px" v-model.number="form.latitude" placeholder="纬度"></el-input>-->
        <mapPointer :show="showMap" :source='{lat:form.latitude,lng:form.longitude}' @change="confirm"></mapPointer>
      </el-form-item>
      <el-form-item label="所属区划" prop="regions" label-width="120px">
        <dataTreeboth @change="changeRegion" :defaultDataval='defaultPointerDataval'></dataTreeboth>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import mapPointer from '../../view/component/MapPointer.vue'
import account from '../../data/basic/plan/company.js'
import dataTree from '../../view/component/Datatree.vue'
import dataTreeboth from '../../view/component/Datatreeboth.vue'
import { mapState } from 'vuex'
export default {
  components: {
    mapPointer,
    dataTree,
    dataTreeboth
  },
  data() {
    return {
      // 省
      pro: '',
      // 市
      city: '',
      // 县
      county: '',
      selectCity: {},
      singleCounty: [],
      prodata: {
        p: '',
        cityy: '',
        countyy: '',
      },
      longitude: '',
      longitude: '',
      showMap: {
        state: false
      },
      // 经纬度
      latlng: {
        lat: '',
        lng: ''
      },
      // 验证
      rules: {
        name: [{
          required: true,
          message: '请输入单位全称的名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入街道详细地址',
          trigger: 'blur'
        }],
        linkMan: [{
          required: true,
          message: '请输入联系人的名称',
          trigger: 'blur'
        }],
        phone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          {
            pattern: /^1\d{10}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        latitude: [{
          type: 'number',
          required: true,
          message: '请选择地图坐标',
          trigger: 'change'
        }],
        regions: [{
          type: 'array',
          required: true,
          message: '请选择区划',
          trigger: 'change'
        }],
      },
      form: {
        linkMan: '',
        address: '', // 地址 ,
        city: '', // 市代码 ,
        cityName: '', // 市名称 ,
        count: '', // 成员数量 ,
        county: '', // 县代码 ,
        countyName: '', // 区/县名称 ,
        createtime: '', // 创建时间 ,
        id: '', // id标识，uuid，由系统产生 ,
        latitude: '', // 纬度 ,
        longitude: '', // 经度 ,
        name: '', // 机构名称 ,
        phone: '', // 电话 ,
        province: '', // 省代码 ,
        provinceName: '', // 省名称 ,
        regionType: 1, //政府： regionType: 1=区县，2=市，3=省
        regions: [], // 区划 ,
        role: 1, // 我的角色,0=管理员，1=普通用户 ,
        type: '',
      },
      defaultPointerData: [],
      defaultData: [],
      RegionPartition: [],
      defaultPointerDataval: [],
      defaultDataval: [],
      //区域检验结果
      validRegion:false,
    }
  },
  mounted() {
    // 初始化区县列表
    this.getCountyList()
    this.initData()
  },
  props: {
    modifyenf: {
      type: Object
    },
    isUpdata: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      dataGovlist(state) {
        return state.dataGovlist
      },
    })
  },

  created() {
    if (this.isUpdata) {
      if (!this.dataGovlist) {
        // console.log(this.isUpdata)
        this.$router.replace('/')
      } else {
        this.form = JSON.parse(JSON.stringify(this.dataGovlist))
        this.defaultPointerData = [this.form.province, this.form.city, this.form.county]
        this.defaultPointerDataval = this.form.regions?[this.getRegionCode(this.form.regions[0].province),this.getRegionCode(this.form.regions[0].city),this.getRegionCode(this.form.regions[0].county[0])]:[]
      }
    }
  },
  methods: {
    getRegionCode(val){
      if(!val){
        return null
      }
      return val.code;
    },
    // 初始化Form表单数据
    initData() {
      if (this.data) {
        this.form = JSON.parse(JSON.stringify(this.data))
      }
    },
    // 提交
    onSubmitgov(formName) {
      this.$refs['otnerform'].validate((valid) => {
        if (valid) {
          this.$emit('change', this.form)
        } else {
          // console.log('错误 submit!!');
          return false;
        }
      });
    },
    // 取消输入的
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 经纬度
    mapclick(val) {
      let lat = val.latlng.lat,
        lng = val.latlng.lng
      this.latlng.lat = lat
      this.latlng.lng = lng
    },
    // 执行确认操作
    confirm(val) {
      this.form.latitude = Math.floor(val.lat * 1000000) / 1000000
      this.form.longitude = Math.floor(val.lng * 1000000) / 1000000
    },
    // 执行取消或者关闭
    cancel(val) {
      this.showMap.state = val
    },
    // Name
    transmitName(name) {
      this.pointerName = name
    },
    // 三级联动数据
    changeId(val) {
      if (val.length === 2) {
        this.form.county = ''
        this.form.city = val[1]
        this.form.province = val[0]
      } else {
        this.form.county = val[2]
        this.form.city = val[1]
        this.form.province = val[0]
      }
    },
    // 获取区县列表
    getCountyList() {
      (async() => {
        this.statelist = await account.get_tree()
        this.pro = this.statelist;
        this.city = this.pro[0]['children'];
        this.county = this.city[0]['children'];
      })()
    },
    // 多级都可选中输入
    changeRegion(val) {
      let provinceData = val[0],
        cityData = val[1],
        countyData = val[2]
      if (provinceData && !cityData && !countyData) {
        this.form.regionType = 3
        this.RegionPartition = {
          province: {
            code: provinceData
          }
        }
      }
      else if (provinceData && cityData && !countyData) {
        this.form.regionType = 2
        this.RegionPartition = {
          province: {
            code: provinceData
          },
          city: {
            code: cityData
          }
        }
      }
      else if (provinceData && cityData && countyData) {
        this.form.regionType = 1
        this.RegionPartition = {
          province: {
            code: provinceData
          },
          city: {
            code: cityData
          },
          county: [{
            code: countyData
          }]
        }
      }
      this.form.regions = [this.RegionPartition]
    }
  }
}

</script>
<style lang="stylus" scoped>
.otherBox {
  padding-bottom: 20px;
  clear: both;
}

.address-p1 {
  display: block;
  width: 400px;
}

.address-p2 {
  display: block;
  width: 400px;
}

.input-w180 {
  width: 180px;
}

.input-w140 {
  width: 140px;
}

.input-w150 {
  width: 140px;
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// Govform.vue?d7abd3ae